export default __webpack_public_path__ + "static/media/Polygon.1cf1d967.svg";